// eslint-disable-next-line
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { checkTimeDifference } from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import { MultiselectField } from "../../../../Components/formElements/MultiselectField";

import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import BuyerAuctionFormModal from "../BuyerAuctionFormModal";
import AuctionCancelModal from "../AuctionCancelModal";
import CreateRFQBidders from "../CreateRFQBidders";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import moment from "moment";
import PageLevelRiverseTimer from "../../../../Components/PageLevelRiverseTimer";
import { getEauction } from "../../../../redux/feature/supplier_app/eauctionSlice";

const SupplierRevAuctionDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let dynamicFormDataCOMM = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataCOMM
  ); // purchase_requisition from Store

  let userData = useSelector((state) => state.eauctionSlice.eauction.data);
  //  console.log("userData",userData)

  let auctionId = useSelector(
    (state) => state.eauctionSlice.eauction.auctionNr
  );
  // console.log("auctionId",auctionId)
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);

  const [getDropdownData, setDropdownData] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const [getINCOTerms, setINCOTerms] = useState([]);
  const [selectedINCOTerms, setSelectedINCOTerms] = useState([]); // Selected ones (from API)

  const [getcurrency, setcurrency] = useState([]);
  // eslint-disable-next-line
  const [getLineItemData, setLineItemData] = useState([]);
  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  const [getFormModalData, setFormModalData] = useState({});
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const RenderInputField = ({ questionData }) => {
    const { componentId, mandatory, question, answerDefinition, serialNo } =
      questionData;

    switch (answerDefinition?.type) {
      case "textarea":
        return (
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <TextAreaField
              label={serialNo + ". " + question?.label}
              id={componentId}
              name={componentId}
              className="inputBox"
              placeholder=""
              // value={getRemarks}
              // onChange={handleInputChange}
              required={mandatory}
            />
          </Col>
        );
      case "select":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <ComboboxField
              label={serialNo + ". " + question?.label}
              placeholder=""
              data={answerDefinition?.options}
              id={componentId}
              iconClassName="dropdownIcon"
              name={componentId}
              code={componentId}
              required={mandatory}
              // setValue={formData.type || ""}
              // getvalue={setDropdownData}
            />
          </Col>
        );
      case "radio":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>

            {answerDefinition?.options.map((option, index) => {
              return (
                <div key={index} className="block">
                  <input
                    type="radio"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    // value={option?.value}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              );
            })}
          </Col>
        );
      case "checkbox":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>

            {answerDefinition?.options.map((option, index) => {
              return (
                <div key={index} className="block">
                  <input
                    type="checkbox"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    // value={option?.value}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              );
            })}
          </Col>
        );
      case "text":
        return (
          <Col
            xs={12}
            md={6}
            lg={6}
            className="commTopButtonRightLeftPadding block"
          >
            <InputField
              label={serialNo + ". " + question?.label}
              type="text"
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              // value={option.value}
              // onChange={(e) =>
              //   handleOptionChange(index, e.target.value)
              // }
              required={mandatory}
            />
          </Col>
        );
      case "number":
        return (
          <Col
            xs={12}
            md={6}
            lg={6}
            className="commTopButtonRightLeftPadding block"
          >
            <InputField
              label={serialNo + ". " + question?.label}
              type="number"
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              // value={option.value}
              // onChange={(e) =>
              //   handleOptionChange(index, e.target.value)
              // }
              required={mandatory}
            />
          </Col>
        );
      default:
        return "";
    }
  };

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    companyCodeType: "",
    paymentTerm: "",
    incoTermsLocation: "",
    openingDate: "",
    openingTime: "",
    closingDate: "",
    auctionType: "",
    referenceRfqNumber: "",
    auctionTitle: "",
    decrementValue: "",
    othercurrencies: "",
    auctionCurrencies: "",
    buyerCategory: "",
    auctionDescription: "",
    allowBidders: "",
    displayBidRank: "",
    ceilingPrice: "",
    tieBidAllowed: "",
    buyerContact: [],
    items: [],
    lineItemWise: "",
    supplierWise: "",
    bidders: [],
    supplierList: [],
  });

  const [getOpenCloseInput, setOpenCloseInput] = useState({});
  const modalData = {
    title: "RFQ Creation",
    successMsg: "",
  };

  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const updateTimerValue = (closingDateTime) => {
    if (!closingDateTime) {
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }
    // Use moment with local timezone parsing
    const closingMoment = moment(closingDateTime);
    const now = moment();
    const diff = closingMoment.diff(now);
    if (diff <= 0) {
      setFinalTimerValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    } else {
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / (24 * 60 * 60));
      const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;
      setFinalTimerValue({ days, hours, minutes, seconds });
    }
  };

  useEffect(() => {
    if (!getOpenCloseInput?.closingDate || !getOpenCloseInput?.closingTime)
      return;

    const closingDateTime = `${getOpenCloseInput.closingDate} ${getOpenCloseInput.closingTime}`;
    updateTimerValue(closingDateTime); // initial call

    const interval = setInterval(() => {
      updateTimerValue(closingDateTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [getOpenCloseInput]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };

  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // This is for Text Editor
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  // eslint-disable-next-line
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.textField === "paymentTerm") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "INCOTerms") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        INCOTerms: getDropdownData?.name,
        INCOTermsCode: getDropdownData?.code,
        INCOTermsDesc: getDropdownData?.description,

        incoTerms: getDropdownData?.selected,
      }));
    } else if (getDropdownData?.textField === "auctionCurrencies") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        auctionCurrencies: getDropdownData?.name,
        auctionCurrenciesCode: getDropdownData?.code,
        auctionCurrenciesDesc: getDropdownData?.description,

        auctionCurrencie: getDropdownData?.selected,
      }));
    } else if (getDropdownData?.textField === "othercurrencies") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        othercurrencies: getDropdownData?.name,
        othercurrenciesCode: getDropdownData?.code,
        othercurrenciesDesc: getDropdownData?.description,

        othercurrencie: getDropdownData?.selected,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // eslint-disable-next-line no-unused-vars
  const [getupdateLogisticsTransport, setupdateLogisticsTransport] = useState();
  /* submit button */
  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return ""; // invalid ayite empty
    return d.toISOString().split("T")[0]; // YYYY-MM-DD
  };

  const loadInitialPageData = async () => {
    if (auctionId) {
      let obj = {
        documentNumber: auctionId,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      try {
        const item = await ItemService.getAuctionDetail(obj);
        if (item?.status === 200) {
          const response = item.data[0];
          setFormInputs((prev) => {
            return {
              ...prev,
              ...response,
            };
          });
          setOpenCloseInput({
            openingTime: response.openingTime || "",
            closingTime: response.closingTime || "",
            openingDate: formatDateForInput(response.openingDate),
            closingDate: formatDateForInput(response.closingDate),
          });
          // if (response.items) setData(response.items);
          // if (response.formCOMM) setDynamicFormDataCOMM(response.formCOMM);
          // if (response.formTECH) setDynamicFormDataTECH(response.formTECH)
          if (response.instructions) setEditorContent(response.instructions);
          if (response.termsConditions)
            setTermsConditionsData(response.termsConditions);
          if (response.bidders) setBiddersData(response.bidders);
          if (response.items) setLineItemsData(response.items);
          if (response.incoTerms) setINCOTerms(response?.incoTerms);
          if (response.incoTerms) {
            setSelectedINCOTerms(response.incoTerms);
            if (response.buyerContact) {
              setbuyerContactData(response.buyerContact);
              setFormInputs((prev) => ({
                ...prev,
                buyerContact: response.buyerContact,
              }));
            }
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (err) {
        console.error("API call error:", err);
        toast.error("Something went wrong", {
          duration: 4000,
          position: "top-right",
        });
      } finally {
        toast.dismiss(toastId);
      }
    } else {
      console.warn("auctionId is missing, cannot load data.");
    }
  };

  useEffect(
    (auctionId) => {
      loadInitialPageData();
    },
    // eslint-disable-next-line
    [auctionId]
  );
  //   eslint-disable-next-line
  const [acknowledged, setAcknowledged] = useState(false);
  //  eslint-disable-next-line
  const [supplierList, setSupplierList] = useState([]); // Assuming this is your table's data source
  // To track if user has already acknowledged

  const handleAcknowledgeClick = async (type) => {
    const status = type === "A" ? "Acknowledged" : "Regret";

    setSupplierList((prev) =>
      prev.map((supplier) =>
        supplier.AssociateNumber === userData?.AssociateNumber
          ? { ...supplier, auctionSupplierStatus: status }
          : supplier
      )
    );

    let obj = {
      auctionNr: formInputs.auctionNr,
      AssociateNumber: userData?.AssociateNumber,
      auctionSupplierStatus: status,
      acceptTermsConditions: true,
      supplierList: [
        {
          AssociateNumber: userData?.AssociateNumber,
          auctionSupplierStatus: status,
        },
      ],
    };

    // Temporarily disable button while API request is in progress
    setDisabled(true);

    try {
      const item = await ItemService.ackOrRegretAuction(obj);

      if (item?.status === 200) {
        toast.success(item?.message, {
          duration: 3000,
          position: "top-right",
        });

        if (status === "Acknowledged") {
          setAcknowledged(true); // This state will control the permanent disable
        }

        dispatch(getEauction({}));
        loadInitialPageData(); // refresh data
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
        setDisabled(false); // re-enable if failed
      }
    } catch (error) {
      console.error("Error acknowledging auction:", error);
      toast.error("Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
      setDisabled(false);
    }
  };
  /* suppplierModalShow */
  const [getSupplierModal, setSupplierModal] = useState(false);
  const supplerMoadHide = () => {
    setSupplierModal(false);
  };
  /* selectedSupplierIds */
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  // eslint-disable-next-line
  const [getSupplierData, setSupplierData] = useState([]);
  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };
  const handlePassDataToParent = (data) => {
    // console.log("Data received from child:", data);
    // You can now use this data in the parent component

    setSupplierData((prevData) => {
      // Combine previous data and filter out duplicates based on id
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber
            )
        ),
      ];

      return updatedData;
    });
  };
  // eslint-disable-next-line
  const [termsConditionsData, setTermsConditionsData] = useState([
    {
      id: 1,
      name: "Terms and Conditions",
      status: true,
      disabled: true,
    },
    {
      id: 2,
      name: "Code of Conduct",
      status: false,
    },
    {
      id: 3,
      name: "Packaging Requirement",
      status: false,
    },
    {
      id: 4,
      name: "Others",
      status: false,
    },
  ]);

  /*  Buyer Line Items*/
  let BuyerContactCol = [
    {
      name: "Document Item Nr",
      // selector: (row) => row.local_id || "--",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "180px",
    },

    {
      name: "Buyer Name ",
      selector: (row) => row.buyerName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="buyerName"
          placeholder=""
          value={row.buyerName || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Buyer Email ",
      selector: (row) => row.buyerEmail || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="buyerEmail"
          placeholder=""
          value={row.buyerEmail || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Mobile Number ",
      selector: (row) => row.buyerNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="buyerNumber"
          placeholder=""
          value={row.buyerNumber || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let buyerContactData = [
    {
      local_id: 1,
      // rfxNr: 1,
      buyerEmail: "",
      buyerName: "",
      buyerNumber: "",
    },
  ];

  /*  Buyer Line Items*/
  let lineItems = [
    {
      name: "Document Item Nr",
      // selector: (row) => row.local_id || "--",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Item No",
      selector: (row) => row.itemNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemNo"
          value={row.itemNo || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "PR Number",
      selector: (row) => row.prNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="prNumber"
          value={row.prNumber || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "PR Line",
      selector: (row) => row.prLine || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="prLine"
          value={row.prLine || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Item Code",
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          value={row.itemCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Description",
      selector: (row) => row.itemDescription || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemDescription"
          value={row.itemDescription || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Item Text",
      selector: (row) => row.itemText || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemText"
          value={row.itemText || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="quantity"
          value={row.quantity || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "150px",
    },
    {
      name: "UOM",
      selector: (row) => row.uom || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="uom"
          value={row.uom || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "120px",
    },
    {
      name: "Internal Rate",
      selector: (row) => row.internalRate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="internalRate"
          value={row.internalRate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Item Value",
      selector: (row) => row.itemValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemValue"
          value={row.itemValue || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "RFQ Value(Min)",
      selector: (row) => row.rfqValueMin || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rfqValueMin"
          value={row.rfqValueMin || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Ceiling Price",
      selector: (row) => row.ceilingPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="ceilingPrice"
          value={row.ceilingPrice || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Auction Value",
      selector: (row) => row.auctionValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="auctionValue"
          value={row.auctionValue || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Requested Delivery Date",
      selector: (row) => row.requestedDeliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="requestedDeliveryDate"
          value={row.requestedDeliveryDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service Header Code",
      selector: (row) => row.serviceHeaderCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="serviceHeaderCode"
          value={row.serviceHeaderCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service Start Date",
      selector: (row) => row.serviceStartDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="serviceStartDate"
          value={row.serviceStartDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service End Date",
      selector: (row) => row.serviceEndDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="serviceEndDate"
          value={row.serviceEndDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Technical Specification",
      selector: (row) => row.technicalSpec || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="technicalSpec"
          value={row.technicalSpec || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "INCO Terms",
      selector: (row) => row.incoTerms || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="incoTerms"
          value={row.incoTerms || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "INCO Terms Location",
      selector: (row) => row.incoTermsLoc || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="incoTermsLoc"
          value={row.incoTermsLoc || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },

    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRowLineItem(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let lineItemsData = [
    {
      local_id: 1,
      rfxNr: 1,

      itemNo: "",
      prNumber: "",
      prLine: "",
      itemCode: "",
      itemDescription: "",
      itemText: "",
      quantity: "",
      uom: "",
      internalRate: "",
      itemValue: "",
      rfqValueMin: "",
      ceilingPrice: "",
      auctionValue: "",
      requestedDeliveryDate: "",
      serviceHeaderCode: "",
      serviceStartDate: "",
      incoTerms: "",
      serviceEndDate: "",
      technicalSpec: "",
      incoTermsLoc: "",
    },
  ];
  // Bidders Line Items
  let bidderColumData = [
    // {
    //   name: "S No",
    //   selector: (row) => row.local_id || "--",
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Supplier Code and Name",
      selector: (row) => row.supplierCodeAndName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="supplierCodeAndName"
          value={row.supplierCodeAndName || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),

      width: "250px",
    },
    {
      name: "Country",
      selector: (row) => row.country || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="country"
          value={row.country || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Email ID",
      selector: (row) => row.emailId || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="emailId"
          value={row.emailId || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Contact No",
      selector: (row) => row.contactNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="contactNo"
          value={row.contactNo || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "User ID",
      selector: (row) => row.userId || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="userId"
          value={row.userId || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRowBiddersItem(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let biddersLineItemData = [
    {
      local_id: 1,
      rfxNr: 1,
      supplierCodeAndName: "",
      country: "",
      emailId: "",
      contactNo: "",
      userId: "",
      // delete: ""
    },
  ];
  // suppliers column data
  // const suppliersColumns = [
  //   {
  //     name: "Supplier ID",
  //     selector: (row) => row.AssociateNumber || "--",
  //     sortable: true,
  //     cell: (row) => (
  //       <button
  //         className="btnInfo"
  //         // onClick={() => detailedPage(row.AssociateNumber)}
  //       >
  //         {row.AssociateNumber || "-"}{" "}
  //       </button>
  //     ),
  //     width: "120px",
  //   },
  //   {
  //     name: "Status",
  //     selector: (row) => row.status,
  //     sortable: true,
  //     cell: (row) => (
  //       <>
  //         <TableStatusField status={row.status} />
  //       </>
  //     ),
  //     width: "170px",
  //   },

  //   {
  //     name: "Name",
  //     selector: (row) => row.organisationName,
  //     sortable: true,
  //     width: "180px",
  //   },
  //   {
  //     name: "SAP Number",
  //     selector: (row) => row.sapAssociateNumber || "--",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Contact Person",
  //     selector: (row) => row.contactfirstName || "--",
  //     sortable: true,
  //     width: "150px",
  //   },

  //   {
  //     name: "Contact Number",
  //     selector: (row) => row.contactNumber || "--",
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "EMail",
  //     selector: (row) => row.email,
  //     sortable: true,
  //     width: "250px",
  //   },
  //   // {
  //   //   name: "Auction Status",
  //   //   selector: (row) => row.auctionSupplierStatus,
  //   //   cell: (row) => (
  //   //     <>
  //   //       {row.auctionSupplierStatus === "Acknowledged" ? (
  //   //         <span className="bg-table-status bg-table-success-status">
  //   //           {row.auctionSupplierStatus}
  //   //         </span>
  //   //       ) : row.auctionSupplierStatus === "Regret" ? (
  //   //         <span className="bg-table-status bg-table-danger-status">
  //   //           {row.auctionSupplierStatus}
  //   //         </span>
  //   //       ) : (
  //   //         row.auctionSupplierStatus || "--"
  //   //       )}
  //   //     </>
  //   //   ),
  //   //   width: "170px",
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Auction Status",
  //     selector: (row) => row.auctionSupplierStatus,
  //     cell: (row) => {
  //       // let formInputs?.auctionSupplierStatus = row.auctionSupplierStatus;
  //       let className = "bg-table-status"; // base class

  //       if (formInputs?.auctionSupplierStatus === "Acknowledged") {
  //         className += " bg-table-success-status"; // green
  //       } else if (formInputs?.auctionSupplierStatus === "Regret") {
  //         className += " bg-table-danger-status"; // red
  //       } else if (formInputs?.auctionSupplierStatus === "Pending") {
  //         className += " bg-table-warning-status"; // yellow
  //       }

  //       return (
  //         <span className={className}>
  //           {formInputs?.auctionSupplierStatus || "--"}
  //         </span>
  //       );
  //     },
  //     width: "170px",
  //     sortable: true,
  //   },

  //   {
  //     name: "Supplier Status",
  //     cell: (row) => (
  //       <>
  //         {row.qtnSupplierStatus === "QTN Received" ? (
  //           <span className="bg-table-status bg-table-progress-status">
  //             {row.qtnSupplierStatus}
  //           </span>
  //         ) : (
  //           "--"
  //         )}
  //       </>
  //     ),
  //     selector: (row) => row.qtnSupplierStatus,
  //     sortable: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Quotation Number",
  //     cell: (row) => (
  //       <>
  //         {row.qtnSupplierStatus === "QTN Received" ? (
  //           <button className="btnInfo">{row.quotationNr}</button>
  //         ) : (
  //           "--"
  //         )}
  //       </>
  //     ),
  //     sortable: true,
  //     width: "180px",
  //   },
  //   {
  //     name: "Quotation Version",
  //     selector: (row) => row.qtnVersion || "--",
  //     sortable: true,
  //     width: "180px",
  //   },
  //   {
  //     name: "Category",
  //     cell: (row) => (
  //       <>
  //         <span
  //           style={{ marginLeft: "12px" }}
  //           // onClick={() => categoryItemShowModal(row.vendorCategory)}
  //         >
  //           <i className="bi bi-calendar2-week iconTable"></i>
  //         </span>
  //         <span className="suppliersIcon">
  //           {" "}
  //           {row.vendorCategory?.length || 0}{" "}
  //         </span>
  //       </>
  //     ),
  //     width: "120px",
  //   },
  //   {
  //     name: "Company Code",
  //     cell: (row) => (
  //       <>
  //         <span> {row.companyCode} </span>
  //       </>
  //     ),
  //     width: "150px",
  //   },
  // ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  const aAuctionCOmpanyCOde = [
    {
      id: 1,
      desc: "",
      name: "SV",
      code: "",
    },
  ];
  const buyerCategories = [
    {
      id: 1,
      desc: "ProcurementDepartmentdesc",
      name: "Procurement Department",
      code: "ProcurementDepartmentcode",
    },
    {
      id: 1,
      desc: "PurchaseManagerdesc",
      name: "Purchase Manager",
      code: "PurchaseManagercode",
    },
    {
      id: 1,
      desc: "ProjectManagerdesc",
      name: "Project Manager",
      code: "ProjectManagercode",
    },
    {
      id: 1,
      desc: "FinanceDepartmentdesc",
      name: "Finance Department",
      code: "FinanceDepartmentcode",
    },
  ];
  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  // eslint-disable-next-line
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  //buyer contat  Data
  const [getbuyerContactData, setbuyerContactData] = useState(buyerContactData);
  useEffect(() => {
    if (getbuyerContactData.length > 0) {
      setFormInputs((prev) => ({
        ...prev,
        buyerContact: getbuyerContactData,
      }));
    }
  }, [getbuyerContactData]);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    setbuyerContactData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  const addPOItemRow = () => {
    setbuyerContactData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;

      const newRow = {
        ...buyerContactData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };

      return [...prevRows, newRow];
    });
  };
  const removePOItemRow = (local_id) => {
    setbuyerContactData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  // Line Items Data
  const [getLineItemstData, setLineItemsData] = useState(lineItemsData);
  const handleLineItemsInputChange = (local_id, event) => {
    const { name, value } = event.target;

    setLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
    // getTotalCount()
  };

  const addPOItemRowLineItem = () => {
    setLineItemsData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;

      const newRow = {
        ...lineItemsData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };

      return [...prevRows, newRow];
    });
  };
  const removePOItemRowLineItem = (local_id) => {
    setLineItemsData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  // Bidders Section
  const [getBiddersData, setBiddersData] = useState(biddersLineItemData);
  const handleBiddersInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;

    setBiddersData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );

    // getTotalCount()
  };

  const addPOItemRowBiddersItem = () => {
    setBiddersData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;

      const newRow = {
        ...biddersLineItemData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };

      return [...prevRows, newRow];
    });
  };
  const removePOItemRowBiddersItem = (local_id) => {
    setBiddersData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  // obj
  const getMasterDataFunc = async () => {
    let obj1 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj7 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj7).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj8 = {
      codeType: "INCOTerms",
    };
    await ItemService.getMasterData(obj8).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  useEffect(() => {
    getMasterDataFunc();

    localStorage.setItem("menu", "eAuction");
    localStorage.setItem("submenu", "Reverse Auction");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line
  const createDynamicformModelCOMM = () => {
    let obj = {
      formType: "COMM",
    };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };

  const hideModalStatus = () => {
    setCreateDynamicformModelShow(false);
  };
  // Render Questions
  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((getOpenCloseInput) => ({
      ...getOpenCloseInput,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);
      // console.log(">> res", res);
      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";

      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        } else {
          // toast.error(res.msg, {
          //   duration: 4000,
          //   position: "top-right",
          // });
        }
      }
    }
  }, [getOpenCloseInput]);
  // For Upload Success
  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  //instruction Bidders
  const [sections, setSections] = useState([
    {
      id: 1,
      title: "Introduction",
      data: [
        {
          key: "•",
          text: "Dear Partners, We are very pleased to invite you to participate in above mentioned Steel Auction as mentioned in Auction Basic Information.",
        },
        {
          key: "•",
          text: "Remark: This is an online bidding, hence doesn't require submission of signed, stamped hard copy proposals. * If you have any questions, please use the messages section in the auction to communicate with the buyer. No other communication channels are available.",
        },
        {
          key: "•",
          text: "Deadline for the auction submission: As shown in the time ticker section on the top of the auction section.",
        },
      ],
    },
  ]);

  // eslint-disable-next-line
  const handleAddPoint = (sectionIndex) => {
    setSections((prev) => {
      const newSections = [...prev];
      const section = newSections[sectionIndex];
      const nextPointNum = (section.data.length + 1).toFixed(1);
      const nextKey = `${section.id}.${nextPointNum}`;
      section.data.push({
        key: nextKey,
        text: "",
        isInput: true,
        inputName: `${section.title.toLowerCase()}_${nextKey.replace(
          ".",
          "_"
        )}`,
      });
      return newSections;
    });
  };

  // eslint-disable-next-line
  const [getDisabled, setDIsabledField] = useState(false);

  useEffect(() => {
    setDIsabledField(true);
  }, []);

  // Auction Cancel Mode
  const [getCancelModalStatus, setCancelModalStatus] = useState(false);

  const cancelModalHide = () => {
    setCancelModalStatus(false);
  };
  // Navigation tolive auction button
  const detailedCommercialEvaluation = (rfxNr) => {
    navigate(Constants.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS);
  };
  const isTimerExpired =
    finalTimerValue.hours === 0 &&
    finalTimerValue.minutes === 0 &&
    finalTimerValue.seconds === 0;

  const navigateToWorkflow = () => {
    window.history.back();
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Supplier Reverse Auction Details
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {auctionId}
              </span>
              <span>
                {formInputs?.auctionSupplierStatus === "Published" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.auctionSupplierStatus}
                  </span>
                ) : formInputs?.auctionSupplierStatus === "QTN Received" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.auctionSupplierStatus}
                  </span>
                ) : formInputs?.auctionSupplierStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.auctionSupplierStatus}
                  </span>
                ) : formInputs?.auctionSupplierStatus === "RFQ Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.auctionSupplierStatus}
                  </span>
                ) : formInputs?.auctionSupplierStatus === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.auctionSupplierStatus}
                  </span>
                ) : (
                  formInputs?.auctionSupplierStatus
                )}
              </span>
            </h2>
            <p className="subText">Supplier Reverse Auction Details</p>
            <hr />
            <Row className="mb-2 accordion-button">
              {/* edit button */}
              <Row className="mb-4">
                <Col xs={12} md={8} lg={8} className="text-left">
                  <button
                    className="btnBack"
                    onClick={() => navigateToWorkflow()}
                  >
                    <i className="bi bi-arrow-return-left"></i> Go Back
                  </button>
                </Col>
                <Col
                    xs={12}
                    md={2}
                    lg={2}
                    className="text-right commLeftRightPadding"
                  >
                  <button
                    className="btnInfo width-100"
                    onClick={detailedCommercialEvaluation}
                    disabled={isTimerExpired}
                    style={{
                      opacity: isTimerExpired ? 0.5 : 1,
                      cursor: isTimerExpired ? "not-allowed" : "pointer",
                    }}
                  >
                    Live Auction
                  </button>
                </Col>

                {/* Acknowledge */}
                <Col
                    xs={12}
                    md={2}
                    lg={2}
                    className="text-right commLeftRightPadding"
                  >
                  <button
                    className="btnApprove width-100"
                    onClick={() => handleAcknowledgeClick("A")}
                    disabled={
                      isTimerExpired ||
                      disabled ||
                      formInputs?.auctionSupplierStatus === "Acknowledged"
                    }
                    style={{
                      opacity:
                        isTimerExpired ||
                        disabled ||
                        formInputs?.auctionSupplierStatus === "Acknowledged"
                          ? 0.5
                          : 1,
                      cursor:
                        isTimerExpired ||
                        disabled ||
                        formInputs?.auctionSupplierStatus === "Acknowledged"
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Acknowledge
                  </button>
                </Col>
              </Row>
            </Row>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={12} md={5} lg={5}>
                      <p className="headerTitle fs-4">
                        Remaining Time for submission
                      </p>
                    </Col>
                    <Col xs={12} md={7} lg={7} className="flex justify-end">
                      <img
                        src="assets/img/stopwatch.png"
                        alt="stopwatch"
                        style={{ width: "60px", height: "58px" }}
                        className="mr-6 mt-1"
                      />
                      <PageLevelRiverseTimer timerData={finalTimerValue} />
                    </Col>
                  </Row>
                </h2>
              </div>
            </div>
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Additional Basic Information
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Auction Basic Information Form
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tentative Start Time"
                          name="openingDate"
                          id="openingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.openingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Duration(HH:MM)"
                          name="openingTime"
                          id="openingTime"
                          // type="time"
                          placeholder=""
                          // value={getOpenCloseInput.openingTime}
                          value={getOpenCloseInput.openingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tentitative End Date"
                          name="closingDate"
                          id="closingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.closingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tentitative End Time(HH:MM)"
                          name="closingTime"
                          id="closingTime"
                          type="time"
                          placeholder=""
                          // value={getOpenCloseInput.closingDate || ""}
                          value={getOpenCloseInput.closingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Auction Type"
                          name="auctionType"
                          id="auctionType"
                          placeholder=""
                          value={formInputs.auctionType || ""}
                          onChange={onInputChange}
                          // disabled={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Reference RFQ Number"
                          name="referenceRfqNumber"
                          id="referenceRfqNumber"
                          value={formInputs.referenceRfqNumber || ""}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Decrement In Auction Currency"
                          name="decrementValue"
                          id="decrementValue"
                          value={formInputs.decrementValue || ""}
                          onChange={onInputChange}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Auction Currency"
                          placeholder="Please select the Other Currencies"
                          data={getcurrency}
                          id="auctionCurrencies"
                          iconClassName="dropdownIcon"
                          name="auctionCurrencies"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          value={formInputs.auctionCurrencies}
                          onChange={(selected) => {
                            setFormInputs((prev) => ({
                              ...prev,
                              auctionCurrencies: selected,
                            }));
                          }}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Other Currency"
                          placeholder="Please select the Other Currencies"
                          data={getcurrency}
                          id="othercurrencies"
                          iconClassName="dropdownIcon"
                          name="othercurrencies"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Buyer Category"
                          data={buyerCategories}
                          name="buyerCategory"
                          id="buyerCategory"
                          // options={buyerCategoryOptions} // [{ label: '200-MRO Spare Parts', value: '200' }]
                          setValue={formInputs.buyerCategory}
                          // onChange={onDropdownChange}
                          required
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Title"
                          name="auctionTitle"
                          id="auctionTitle"
                          placeholder=""
                          value={formInputs.auctionTitle || ""}
                          onChange={onInputChange}
                          required
                          showTooltip
                          disabled={getDisabled}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Description"
                          name="auctionDescription"
                          id="auctionDescription"
                          value={formInputs.auctionDescription || ""}
                          onChange={onInputChange}
                          required
                          showTooltip
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Line Items 06*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">
                        Supplier Reverse Auction Contact Information
                      </span>
                      <span className="subHeaderTitle">
                        Supplier Reverse Auction Contact Information Details
                      </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {!getDisabled && (
                        <Col xs={4} md={2} lg={2} className="">
                          <button className="btnTable" onClick={addPOItemRow}>
                            +
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={BuyerContactCol}
                          data={getbuyerContactData}
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents 05 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Supplier Reverse Actions Rules And Settings
                      </span>
                      <span className="subHeaderTitle">
                        Supplier Reverse Actions Rules And Settings Form
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.others && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() => handleViewFile(formInputs?.others)}
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="allowBidders"
                          >
                            Allow Bidders To Select Item For Bidding
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="allowBidders"
                            id="allowBidders"
                            checked={formInputs?.allowBidders || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                allowBidders: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.allowBidders ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="displayBidRank"
                          >
                            Display Bid Rank
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="displayBidRank"
                            id="displayBidRank"
                            checked={formInputs?.displayBidRank || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                displayBidRank: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.displayBidRank ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="ceilingPrice"
                          >
                            Celling Price
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="ceilingPrice"
                            id="ceilingPrice"
                            checked={formInputs?.ceilingPrice || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                ceilingPrice: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.ceilingPrice ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="tieBidAllowed"
                          >
                            Tie Bid Allow
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="tieBidAllowed"
                            id="tieBidAllowed"
                            checked={formInputs?.tieBidAllowed || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                tieBidAllowed: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.tieBidAllowed ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Revrse Auction Auto Extension Rules 07*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible7
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AR</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">
                        Revrse Auction Auto Extension Rules
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Auction Auto Extension Rules and Settings
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible7 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="When new bid is received for the below mentioned bid level"
                          // data={bidTimeOptions}
                          id="newBidReceived"
                          iconClassName="dropdownIcon"
                          name="newBidReceived"
                          setValue={formInputs?.newBidReceived}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Auction will be auto-extended by below mentioned minutes"
                          // data={auctionExtendedOptions}
                          id="auctionAutoExtended"
                          iconClassName="dropdownIcon"
                          name="auctionAutoExtended"
                          setValue={formInputs?.auctionAutoExtended}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="When new bid is received for the below mentioned bid level"
                          // data={newBidReceivedOptions}
                          id="newBidReceivedTime"
                          iconClassName="dropdownIcon"
                          name="newBidReceivedTime"
                          setValue={formInputs?.newBidReceivedTime}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* COMM - Spares & Operation Maintenance 08*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IB</span>
                    </Col>

                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Form: Instructions Bidders
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      md={5}
                      lg={5}
                      className="headerButtonAlign"
                    ></Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row></Row>
                  </div>

                  {/* <div>
                               {sections.map((section, sectionIndex) => (
                                 <Row key={section.id} className="mb-3 p-3 border rounded">
                                   <Col xs={12}>
                                     <h5 className="mb-3">{section.title}</h5>
           
                                     {section.data.map((point, pointIndex) => (
                                       <div key={point.key} className="p-1">
                                         <strong>{point.key}</strong>{" "}
                                         {point.isInput ? (
                                           <Row className="align-items-center mt-1">
                                             <Col xs={12} sm={6} md={4}>
                                               <InputField
                                                 name={point.inputName}
                                                 value={formInputs[point.inputName] || ""}
                                                 onChange={onInputChange}
                                                 className="inputBox"
                                               />
                                             </Col>
                                           </Row>
                                         ) : (
                                           point.text
                                         )}
                                       </div>
                                     ))}
           
                                     <div className="mt-3">
                                       <button
                                         className="btn btnTable"
                                         size="sm"
                                         onClick={() => handleAddPoint(sectionIndex)}
                                       >
                                         + Add Point
                                       </button>
                                     </div>
                                   </Col>
                                 </Row>
                               ))}
                             </div> */}

                  <div className="accordion mb-1 p-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible12
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility12}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">IN</span>
                          </Col>

                          <Col xs={8} md={6} lg={6}>
                            <span className="headerTitle">1.Intruduction</span>
                          </Col>

                          <Col
                            xs={12}
                            md={5}
                            lg={5}
                            className="headerButtonAlign"
                          >
                            <Col xs={6} md={4} lg={4} className="">
                              <button
                                className="btnTable"
                                onClick={createDynamicformModelCOMM}
                              >
                                <i className="bi bi-plus-lg"></i>{" "}
                                {dynamicFormDataCOMM.length > 0
                                  ? "Modify Form"
                                  : "Generate Form"}
                              </button>
                            </Col>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible12 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row></Row>
                        </div>
                        <Row className="mb-1 p-3">
                          {/* <Col xs={12}>
                                       <div className="p-1">
                                         <strong>1.1</strong> Dear Partners, We are very pleased to invite you to participate in above mentioned Emirates Steel Auction as mentioned in Auction Basic Information.
                                       </div>
                                       <div className="p-1">
                                         <strong>1.2 Remark:</strong> This is an online bidding, hence doesn't require submission of signed, stamped hard copy proposals.
                                         <span style={{ fontWeight: 'bold' }}> * </span> If you have any questions, please use the messages section in the auction to communicate with the buyer. No other communication channels are available.
                                       </div>
                                       <div className="p-1">
                                         <strong>1.3 Deadline for the auction submission:</strong> As shown in the time ticker section on the top of the auction section.
                                       </div>
                                       <Row className="mb-3 align-items-center">
                                         <Col xs="auto " className="me-3">
                                           <div>
                                             <strong>1.4 Reverse Test</strong>
                                           </div>
                                         </Col>
           
                                         <Col xs={12} sm={6} md={3} className="p-1">
                                           <InputField
                                             // label="Reverse Test Input"
                                             name="reverseTest"
                                             id="reverseTest"
                                             value={formInputs.reverseTest || ""}
                                             onChange={onInputChange}
                                             className="inputBox"
                                           />
                                         </Col>
                                             {dynamicFormDataCOMM.length > 0 &&
                                               dynamicFormDataCOMM.map((formJsonData, index) => {
                                                 return (
                                                   <RenderInputField
                                                     questionData={formJsonData}
                                                     key={index}
                                                   />
                                                 );
                                               })}
           
                                             {dynamicFormDataCOMM.length === 0 && (
                                               <p className="text-center mt-4">
                                                 {" "}
                                                 Please Generate Form !!
                                               </p>
                                             )}
                                       </Row>
                                     </Col> */}

                          {sections.map((section, sectionIndex) => (
                            <Row
                              key={section.id}
                              className="mb-3 p-3 border rounded"
                            >
                              <Col xs={12}>
                                <h5 className="mb-3">{section.title}</h5>

                                {section.data.map((point, pointIndex) => (
                                  <div key={point.key} className="p-1">
                                    <strong>{point.key}</strong>{" "}
                                    {point.isInput ? (
                                      <Row className="align-items-center mt-1">
                                        <Col xs={12} sm={6} md={4}>
                                          <InputField
                                            name={point.inputName}
                                            value={
                                              formInputs[point.inputName] || ""
                                            }
                                            onChange={onInputChange}
                                            className="inputBox"
                                          />
                                        </Col>
                                      </Row>
                                    ) : (
                                      point.text
                                    )}
                                  </div>
                                ))}

                                <Col xs={12} md={12} lg={12}>
                                  {dynamicFormDataCOMM.length > 0 ? (
                                    dynamicFormDataCOMM.map(
                                      (formJsonData, index) => (
                                        <RenderInputField
                                          questionData={formJsonData}
                                          key={index}
                                        />
                                      )
                                    )
                                  ) : (
                                    <p className="text-center mt-4">
                                      Please Generate Form !!
                                    </p>
                                  )}
                                </Col>
                              </Col>
                            </Row>
                          ))}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Supplier Reverse Auction Additional Information
                      </span>
                      <span className="subHeaderTitle">
                        Supplier Auction Additional Information Form
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          placeholder=""
                          data={aAuctionCOmpanyCOde}
                          id="companyCodeType"
                          iconClassName="dropdownIcon"
                          name="companyCodeType"
                          code="companyCodeTypeCode"
                          description="companyCodeTypeDesc"
                          setValue={formInputs.companyCodeType || ""}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                          // disabled={getDisabled}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Payment Term"
                          placeholder=""
                          data={getpaymentTerm}
                          id="paymentTerm"
                          iconClassName="dropdownIcon"
                          name="paymentTerm"
                          setValue={formInputs.paymentTerm || ""}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                          // disabled={getDisabled}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="INCO Terms"
                          placeholder="Please select the INCO Terms"
                          data={getINCOTerms}
                          id="INCOTerms"
                          iconClassName="dropdownIcon"
                          name="INCOTerms"
                          setValue={selectedINCOTerms}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="INCO Terms Location"
                          name="incoTermsLocation"
                          id="incoTermsLocation"
                          placeholder=""
                          value={formInputs.incoTermsLocation || ""}
                          onChange={onInputChange}
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility10}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AN</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Reverse Auction Note</span>
                      <span className="subHeaderTitle">
                        Reverse Auction RUles And Notes
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible10 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={editorContent}
                          onChange={handleEditorChange}
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CS</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Ceiling Price And Settings
                      </span>
                      <span className="subHeaderTitle">
                        Ceiling Price And Settings Form
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} className="mb-1 mt-2 ms-3">
                        <h4 className="fw-bold">
                          CeilingPrice <span className="text-danger">*</span>
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="lineItemWise"
                          >
                            LineItem Wise
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="lineItemWise"
                            id="lineItemWise"
                            checked={formInputs?.lineItemWise || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                lineItemWise: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.lineItemWise ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="supplierWise"
                          >
                            Supplier Wise
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="supplierWise"
                            id="supplierWise"
                            checked={formInputs?.supplierWise || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                supplierWise: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.supplierWise ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IB</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Items For Bidding</span>
                      <span className="subHeaderTitle">
                        Auction Contact Information Details
                      </span>
                    </Col>
                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {!getDisabled && (
                        <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={addPOItemRowLineItem}
                          >
                            +
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={lineItems}
                          data={getLineItemstData}
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* items For Bidding */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BS</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Bidders</span>
                      <span className="subHeaderTitle">Bidders Section</span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {!getDisabled && (
                        <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={addPOItemRowBiddersItem}
                          >
                            +
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={bidderColumData}
                          data={getBiddersData}
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SD</span>
                    </Col>
                    <Col xs={12} md={6} lg={7}>
                      <span className="headerTitle">Suppliers</span>
                      <span className="subHeaderTitle">
                        Selected Suppliers Details
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={suppliersColumns}
                          data={formInputs?.supplierList}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </Col>
      </Row>
      <CreateRFQBidders
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />
      <BuyerAuctionFormModal
        show={getCreateDynamicformModelShow}
        onHide={() => hideModalStatus()}
        modeldata={getFormModalData}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <AuctionCancelModal
        title="Cancel the Auction"
        type={"Auction"}
        show={getCancelModalStatus}
        onHide={cancelModalHide}
        // selectedrow={getSelectedRows}
      />
    </main>
  );
};

export default SupplierRevAuctionDetails;
